import React from "react";
import SFSplideContainer from "../splide/splideContainer";
const SFHeroContainer = ({ children , notLoading = true }) => {
  const options = {
    type: "loop",
    rewind: true,
    width: "100%",
    height: 335, //461,
    gap: 40,
    perPage: 1,
    perMove: 1,
    //autoWidth: true,
    autoplay: notLoading,
    pauseOnHover: true,
    interval: 5000,
    speed: 1500,
    pagination: notLoading,
    padding: { top: 24, left: 82, right: 82, bottom: 24 },
    arrows: children.length > 1,
  };

  return <SFSplideContainer children={children} options={options} />;
};

export default SFHeroContainer;
